import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { UserConfigsStoreFacade } from '../stores/global-store/user-configs/user-configs-store.facade';

export const userRequestedViewInterceptor: HttpInterceptorFn = (request, next) => {
  const userConfigsFacade = inject(UserConfigsStoreFacade);

  const currentView = userConfigsFacade.currentViewSignal();
  const currentCountryCode = userConfigsFacade.currentCountryCodeSignal();
  const currentCustomerErpRef = userConfigsFacade.currentCustomerErpRefSignal();
  const currentReason = userConfigsFacade.currentReasonSignal();

  if (request.url.includes('resi.bbraun') || request.url.includes('localhost')) {
    let headers = request.headers;

    if (currentView) {
      headers = headers.append('User-Scope-View', userConfigsFacade.currentViewSignal());
    }
    if (currentCountryCode) {
      headers = headers.append('User-Scope-Country-Code', userConfigsFacade.currentCountryCodeSignal());
    }
    if (currentCustomerErpRef) {
      headers = headers.append('User-Scope-Customer-Erp-Number', userConfigsFacade.currentCustomerErpRefSignal()!);
    }

    if (currentReason) {
      headers = headers.append('User-Scope-Reason', currentReason);
    }

    return next(request.clone({ headers }));
  }

  return next(request);
};
